import React, { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import { Link, Route, withRouter } from 'react-router-dom';
import AppLogo from './AppLogo';
import '../css/Toolbar.css';
import Media from 'react-media';
import theme from '../theme';
import Drawer from 'material-ui/Drawer';
import MenuItem from 'material-ui/MenuItem';
import Toolbar from 'material-ui/Toolbar';
import SettingsBar from './SettingsBarContainer';
import MenuIcon from 'material-ui/svg-icons/navigation/menu';
import CloseIcon from 'material-ui/svg-icons/navigation/close';

// XXX: 0.x.x versions of Material-UI have default inline styles
// that's why we need !important declarations to override them
// and still use all the benefits of styled-components like
// browser prefixing
// TODO: remove !important when all defaults will be regular css
const ResponsiveToolbar = styled(Toolbar)`
  display: flex;
  background: rgba(0, 0, 0, 0.87) !important;
  justify-content: space-between !important;
  align-items: center;
  flex-wrap: wrap !important;
  min-height: 56px;
  height: auto !important;
`;

const menuStyles = {
  color: 'white',
  fontSize: '32px',
  textTransform: 'uppercase',
  fontWeight: '300',
  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  lineHeight: '34px',
  letterSpacing: '1px',
  paddingLeft: '14px',
  paddingBottom: '24px',
};

class PrimaryToolbar extends Component {
  constructor() {
    super();
    this.state = {
      menuOpen: false,
    };
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  toggleMenu(event) {
    this.setState({
      menuOpen: !this.state.menuOpen,
    });
  }

  render() {
    const { location } = this.props;

    return (
      <ResponsiveToolbar>
        <div className="appLogo">
          <AppLogo color="white" />
        </div>
        <div className="settingsBarWrap">
          <Route
            path="/(map|chart|table)/:cityId?"
            render={props => (
              <React.Fragment>
                <SettingsBar {...props} />
              </React.Fragment>
            )}
          />
        </div>
        <Media query={theme.media.mobile}>
          {mobile => {
            return (
              <div className="burgerWrap">
                <div
                  onClick={this.toggleMenu}
                  className={
                    'burger cursor ' + (this.state.menuOpen && 'close-burger')
                  }
                >
                  <span
                    style={{
                      color: 'white',
                      fontSize: '13px',
                      verticalAlign: 'top',
                      marginRight: '5px',
                      lineHeight: '35px',
                    }}
                  >
                    MENU
                  </span>
                  <MenuIcon style={{ color: 'white', marginTop: '5px' }} />
                </div>
                <Drawer
                  width={mobile ? '100%' : 500}
                  openSecondary={true}
                  open={this.state.menuOpen}
                  onRequestChange={menuOpen => this.setState({ menuOpen })}
                  docked={false}
                  overlayStyle={{
                    backgroundColor: 'rgba(0, 0, 0, 0.25)',
                  }}
                  containerStyle={{
                    backgroundColor: '#2A2A2A',
                    color: 'white',
                  }}
                  style={{
                    color: 'white',
                    textAlign: 'left',
                  }}
                >
                  <div style={{ textAlign: 'right' }}>
                    <CloseIcon
                      onClick={this.toggleMenu}
                      style={{
                        color: 'white',
                        margin: '15px 20px 0',
                        cursor: 'pointer',
                        height: '30px',
                        width: '30px',
                      }}
                    />
                  </div>
                  <MenuItem
                    containerElement={
                      <Link
                        to={{ pathname: '/map', search: location.search }}
                      />
                    }
                    onClick={this.toggleMenu}
                    style={menuStyles}
                  >
                    Explore Data
                  </MenuItem>
                  <MenuItem
                    containerElement={
                      <Link
                        to={{ pathname: '/cities', search: location.search }}
                      />
                    }
                    onClick={this.toggleMenu}
                    style={menuStyles}
                  >
                    CITIES & METHODOLOGY
                  </MenuItem>
                  <MenuItem
                    containerElement={
                      <Link
                        to={{ pathname: '/about', search: location.search }}
                      />
                    }
                    onClick={this.toggleMenu}
                    style={menuStyles}
                  >
                    About
                  </MenuItem>
                  <MenuItem
                    containerElement={
                      <Link
                        to={{ pathname: '/news', search: location.search }}
                      />
                    }
                    onClick={this.toggleMenu}
                    style={menuStyles}
                  >
                    RESEARCH
                  </MenuItem>
                </Drawer>
              </div>
            );
          }}
        </Media>
      </ResponsiveToolbar>
    );
  }
}

export default withTheme(withRouter(PrimaryToolbar));



// WEBPACK FOOTER //
// ./src/components/PrimaryToolbar.jsx